import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { updateCart } from "../../../../v1/actions/user"
import { useTranslation } from "react-i18next"
import { getUpdatedCart, isEbayTireOrder } from "../../../../v1/helpers/orderHelpers"
import { Divider, Form, FormField, Header, Message } from "semantic-ui-react"
import { AccordionTitle, AccordionContent, Accordion, Icon } from "semantic-ui-react"
import ServiceTile from "./ServiceTile"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import { PricedAtShop } from "../PricedAtShop"
import ApplyPromotionV2 from "../../ApplyPromotionV2"
import { INSTACART, INSTACART_CANADA } from "../../../../v1/constants/affiliations"
import InfoIcon from "../../../../images/info-Icon.svg"
import { ShimmerServiceCard } from "../../Services/ShimmerServiceCard"
import priceTagBlack from "../../../../images/price-tag-black.svg"
import { Image } from "semantic-ui-react"
import { routerPaths } from "../../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import instacartDiscountIcon from "../../../../images/instacart_discount_icon.svg"
import { isEbayUser } from "../../../../v1/helpers/affiliationHelpers"
import Notifications from "../../../../v1/components/Notifications"
import store from "../../../../shared_component/utils/configureStore"

const ReviewServices = (props) => {
  const [pricedServices, setPricedServices] = useState([])
  const [noPricedServices, setNoPricedServices] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [activeIndex, setActiveIndex] = useState(-1)
  const [promoActiveIndex, setPromoActiveIndex] = useState(-1)
  const { cart, user, order, customerNote, handleCustomerNote, history } = props
  const { t } = useTranslation("serviceRequest")
  const sub_total = cart ? cart.estimated_total_pre_tax - cart.transaction_fee : 0
  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false
  const isEbayTireCart = isEbayUser(user) && isEbayTireOrder(cart)

  useEffect(() => {
    getServices()
  }, [cart])

  const getServices = () => {
    let updatedCartData = getUpdatedCart(user, order, props)
    const orderServices = updatedCartData.cart.order_services
    if (orderServices !== null) {
      const _pricedServices = orderServices?.filter(
        (service) => !!service?.price_estimate?.shop_price_estimate
      )
      const _noPricedServices = orderServices?.filter(
        (service) => !!!service?.price_estimate?.shop_price_estimate
      )

      if (isEbayTireOrder(cart ?? order)) {
        _pricedServices.push(..._noPricedServices)
      }

      setPricedServices(_pricedServices)
      !isEbayTireOrder(cart ?? order) && setNoPricedServices(_noPricedServices)
    }
  }

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index

    setActiveIndex(newIndex)
  }

  const handlePromoClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = promoActiveIndex === index ? -1 : index

    setPromoActiveIndex(newIndex)
  }

  const removeService = async (os, event) => {
    if (cart?.order_services?.length == 1) {
      store.dispatch(
        Notifications.error({
          title: t("Error"),
          message: "At least one service is required in the cart.",
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      return
    }
    setIsLoading(true)
    const { activeVehicle, isCart, order } = props
    let opts = {
      isOrder: !isCart && order && !order.is_tire_order,
      orderId: order && order.id,
      successCallback: async () => {
        trackFirebaseAnalytics({
          event: gaJSON.service_selected,
          params: {
            [gaJSON.service_name]: os.name,
            [gaJSON.service_type]: !os.position ? os.name : `${os.name} - ${os.position}`,
            [gaJSON.from_where]: window.location.hash,
            [gaJSON.vehicle_name]: activeVehicle
              ? `${activeVehicle?.year || ""} ${activeVehicle?.make?.toUpperCase() || ""} ${
                  activeVehicle?.model?.toUpperCase() || ""
                }`
              : null
          }
        })
      }
    }
    try {
      await props.updateCart(
        [
          {
            service_definition_id: os.service_id || os.id || os.service_definition_id,
            event: event,
            prepaid: os.prepaid,
            position: os.position
          }
        ],
        props.cart.vehicle_id,
        undefined,
        undefined,
        opts
      )
      getServices()
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      return { error: error.message }
    }
  }

  return (
    <div className="review-services">
      <div className="review-services-title">
        <Header as="h3">{t("serviceRequested")}</Header>
        <div className="spacer-10" />
        {user && user.country !== "ca" && cart && cart.estimated_total > 0 && (
          <div className="review-title-price">
            {t("starting")} ${cart.estimated_total.toFixed?.(2)}
          </div>
        )}
      </div>
      <div className="priced-at-shop-banner">
        <img className="discount-icon-review" src={InfoIcon} />
        <div className="text-block">
          <span>{t("theShopMayRecommend")} </span>
        </div>
      </div>
      <Divider />
      {cart.order_services.length == 0 && (
        <Message size="mini" negative>
          {t("pleaseAddAtLeast")}
        </Message>
      )}
      {!isEbayTireCart && !isOilChangeService && (
        <p
          className="link-text"
          onClick={() => {
            history.push({
              pathname: routerPaths.selectService
            })
          }}
        >
          {t("addMoreServices")}
        </p>
      )}
      {isLoading && <ShimmerServiceCard count={7} />}
      {!isLoading && (
        <>
          <Accordion>
            {pricedServices.length > 0 && (
              <>
                <AccordionTitle active={activeIndex === 0} index={0} onClick={handleClick}>
                  <div className="accordion-title">
                    <div>
                      <Icon
                        className="accordion_icon"
                        name={activeIndex === 0 ? "chevron up" : "chevron down"}
                      />
                      <b>
                        {t("upfrontPricing")} ({pricedServices.length})
                      </b>
                    </div>
                    {user && user.country !== "ca" && cart && cart.estimated_total > 0 && (
                      <div className="accordion-title-price">
                        ${cart.estimated_total.toFixed?.(2)}
                      </div>
                    )}
                  </div>
                </AccordionTitle>
                <AccordionContent active={activeIndex === 0}>
                  {pricedServices &&
                    pricedServices.map((service, index) => (
                      <>
                        <ServiceTile
                          key={service.id}
                          service={service}
                          handleService={removeService}
                          cart={cart}
                        />
                      </>
                    ))}
                  {user && user.country !== "ca" && (
                    <>
                      <div className="spacer-10" />
                      {cart && !cart.any_order_service_lacks_price && (
                        <>
                          <div className="spacer-20" />
                          <div className="row-space-between">
                            <div style={{ color: "#616161" }}>{t("subtotal")}</div>
                            <div className="membership-discount">
                              ${Number(sub_total).toFixed?.(2)}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  <div className="spacer-10" />
                  {!cart?.opt_in_discount &&
                    ((user &&
                      user.country === "ca" &&
                      cart &&
                      cart.promotions.length > 0 &&
                      cart.promotions[0].discount > 0) ||
                      (cart &&
                        cart.any_order_service_lacks_price &&
                        cart.promotions.length > 0 &&
                        cart.promotions[0].discount > 0)) && (
                      <>
                        <div className="row-space-between">
                          {isInstacartUser ? (
                            <div style={{ display: "flex", gap: "10px" }}>
                              <div className="promotional-discount">{t("instacartBenefit")}</div>
                              <img className="discount-icon-review" src={instacartDiscountIcon} />
                            </div>
                          ) : (
                            <div className="promotional-discount">{t("carAdviseBenefit")}</div>
                          )}
                          <div style={{ color: "#2D765E" }} className="font-bold">
                            {cart.promotions[0].discount}% {t("off")}
                          </div>
                        </div>
                      </>
                    )}
                  {user && user.country !== "ca" && cart.promotional_discount > 0 && (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="row-space-between">
                        {isInstacartUser ? (
                          <div style={{ display: "flex", gap: "10px" }}>
                            <div className="promotional-discount">{t("instacartDiscount")}</div>
                            <img className="discount-icon-review" src={instacartDiscountIcon} />
                          </div>
                        ) : user?.marketing_opt_in && isEbayUser ? (
                          <div className="promotional-discount">{cart?.promotions[0]?.name}*</div>
                        ) : (
                          <div className="promotional-discount">{t("carAdviseDiscount")}</div>
                        )}
                        <div className="font-bold" style={{ color: "#282828" }}>
                          -${cart?.promotional_discount?.toFixed?.(2) || ""}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="spacer-10" />
                  {((user &&
                    user.country === "ca" &&
                    user.membership &&
                    user.membership.percent_discount &&
                    user.membership.percent_discount > 0) ||
                    (cart &&
                      cart.any_order_service_lacks_price &&
                      user &&
                      user.membership &&
                      user.membership.plan_name !== "Basic" &&
                      user.membership.percent_discount > 0)) && (
                    <div className="row-space-between">
                      <div className="promotional-discount">{t("premiumMembershipBenefit")}</div>
                      <div style={{ color: "#2D765E" }} className="font-bold">
                        {user.membership.percent_discount}% {t("off")}
                      </div>
                    </div>
                  )}
                  {user && user.country !== "ca" && cart && cart.membership_discount > 0 && (
                    <div className="row-space-between">
                      <div className="promotional-discount">{t("premiumMembershipDiscount")}</div>
                      <div className="font-bold" style={{ color: "#282828" }}>
                        -${Number(cart.membership_discount).toFixed?.(2)}
                      </div>
                    </div>
                  )}
                  {!isEbayTireCart && (
                    <Accordion>
                      <AccordionTitle
                        active={promoActiveIndex === 0}
                        index={0}
                        onClick={handlePromoClick}
                      >
                        <Icon
                          className="accordion_icon"
                          name={promoActiveIndex === 2 ? "chevron up" : "chevron down"}
                        />
                        <Image src={priceTagBlack} className="promo-image" />
                        {t("addPromoCode")}
                      </AccordionTitle>
                      <AccordionContent active={promoActiveIndex === 0}>
                        <ApplyPromotionV2 cart={cart} />
                      </AccordionContent>
                    </Accordion>
                  )}
                  {user && user.country !== "ca" ? (
                    <>
                      {cart && !cart.any_order_service_lacks_price && cart.transaction_fee > 0 && (
                        <>
                          <div className="spacer-20" />
                          <div className="row-space-between">
                            <div style={{ color: "#616161" }}>{t("convenienceFee")}</div>
                            <div className="membership-discount">${cart.transaction_fee}</div>
                          </div>
                        </>
                      )}
                      {cart && !cart.any_order_service_lacks_price && (
                        <>
                          <div className="spacer-20" />
                          <div className="row-space-between">
                            <div style={{ color: "#616161" }}>{t("taxes")}</div>
                            <div className="membership-discount">
                              $
                              {Number(
                                Number(sub_total) * Number(cart.combined_sales_tax_from_service)
                              ).toFixed?.(2)}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="spacer-20" />
                  <div className="row-space-between estimated-total">
                    <div>{t("estimatedTotal")}*</div>
                    {user && user.country !== "ca" && cart && cart.estimated_total > 0 ? (
                      <div>${cart.estimated_total.toFixed?.(2)}</div>
                    ) : (
                      <div style={{ fontSize: "20px" }}>
                        <PricedAtShop />
                      </div>
                    )}
                  </div>
                  {user && user.country !== "ca" && cart && !cart.any_order_service_lacks_price ? (
                    <div className="row-flex-start" style={{ fontWeight: 100, fontSize: "14px" }}>
                      *{t("subjectToChangeBasedOnFinalWorkOrder")}
                    </div>
                  ) : (
                    <div
                      className="row-flex-start"
                      style={{
                        fontWeight: 100,
                        fontSize: "14px",
                        textAlign: "justify",
                        lineHeight: "16px"
                      }}
                    >
                      *{t("excludesSalesTaxAndConvenienceFeeWhichWillBeAddedToAllOrders")}
                    </div>
                  )}
                  {user &&
                    user.country !== "ca" &&
                    cart &&
                    !cart.any_order_service_lacks_price &&
                    cart.total_savings > 0 && (
                      <>
                        <div className="spacer-20" />
                        <div
                          className="row-space-between"
                          style={{ fontWeight: 500, fontSize: "14px" }}
                        >
                          <div>{t("totalSavings")}</div>
                          <div>${Number(cart?.total_savings).toFixed?.(2) || ""}</div>
                        </div>
                      </>
                    )}
                </AccordionContent>
              </>
            )}

            {noPricedServices.length > 0 && (
              <>
                <Divider />
                <AccordionTitle active={activeIndex === 1} index={1} onClick={handleClick}>
                  <Icon
                    className="accordion_icon"
                    name={activeIndex === 1 ? "chevron up" : "chevron down"}
                  />
                  <b>
                    {t("pricedAtShop")} ({noPricedServices.length})
                  </b>
                </AccordionTitle>
                <AccordionContent active={activeIndex === 1}>
                  <div className="priced-at-shop-banner">
                    <img className="discount-icon-review" src={InfoIcon} />
                    <div className="text-block">
                      <span>{t("theShopWillProvide")} </span>
                    </div>
                  </div>
                  <div className="spacer-20" />
                  {noPricedServices.length > 0 && (
                    <div className="common-services">
                      {noPricedServices &&
                        noPricedServices.map((service, index) => (
                          <>
                            <ServiceTile
                              key={service.id}
                              service={service}
                              handleService={removeService}
                            />
                          </>
                        ))}
                    </div>
                  )}
                </AccordionContent>
              </>
            )}

            <Divider />
            <AccordionTitle active={activeIndex === 2} index={2} onClick={handleClick}>
              <Icon
                className="accordion_icon"
                name={activeIndex === 2 ? "chevron up" : "chevron down"}
              />
              <b>{t("addNotes")}</b>
            </AccordionTitle>
            <AccordionContent active={activeIndex === 2}>
              <p>{t("letUsKnow")}</p>
              <Form>
                <FormField>
                  <textarea
                    minLength={100}
                    rows={5}
                    placeholder={t("hearingASquealingNoise")}
                    value={customerNote}
                    onChange={handleCustomerNote}
                    style={{ width: "auto" }}
                  />
                  <div style={{ textAlign: "right" }}>
                    {customerNote.length}
                    {t("minCharacters")}
                  </div>
                </FormField>
              </Form>
            </AccordionContent>
          </Accordion>
        </>
      )}
    </div>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }
  return {
    cart: cart,
    user: user,
    activeVehicle,
    order
  }
}

export default withRouter(connect(mapStateToProps, { updateCart })(ReviewServices))
